const phoneNumberLength = 10;
/**
 * Validate phone number, check if the string contains 10 digits
 * @param val
 */
const validatePhone = (val) => {
    var _a, _b;
    if (val && (val === null || val === void 0 ? void 0 : val.match(/\d/g))) {
        return ((_b = (_a = val === null || val === void 0 ? void 0 : val.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.join('')) === null || _b === void 0 ? void 0 : _b.length) === phoneNumberLength;
    }
    return false;
};
export default validatePhone;
